import { useParams } from "react-router-dom";
import ResourceEditor from "components/cms/ResourceEditor";
import NewsletterIssueStack from "components/cms/NewsletterIssueStack";
import {
  addNewsletterIssue,
  emptyNewsletterIssue,
  getNewsletterIssue,
  prepareNewsletterIssue,
  updateNewsletterIssue,
} from "api/newsletterissue";

export default function NewsletterIssueEditPage() {
  const { id } = useParams();
  const isNew = !id || id === "new";

  return (
    <ResourceEditor
      id={id}
      isNew={isNew}
      empty={emptyNewsletterIssue}
      load={getNewsletterIssue}
      create={addNewsletterIssue}
      update={updateNewsletterIssue}
      prepare={prepareNewsletterIssue}
      listHref="/admin/newsletter-issues"
      label="issue"
    >
      {(props) => <NewsletterIssueStack {...props} />}
    </ResourceEditor>
  );
}
